import React from "react";

import { View } from "react-native";
import Text from "components/Text";
import Icon from "components/Icon";
import Button from "components/Button";
import ConfirmAlert from "components/ConfirmAlert";

import { colors, sizes, strings } from "assets/constants";
import { useLogout } from "clients/apis";
import { useFlag } from "hooks";
import css from "styles";
import { mq } from "utils";

function LogoutAlertContent(props: {
  logout: () => void;
  cancel: () => void;
  logoutLoading: boolean;
}) {
  const { logout, cancel, logoutLoading } = props;

  return (
    <View style={{ ...css.centralElements }}>
      <Icon color={colors.danger} name="log-out" />
      <Text weight="bold" size={"xl"}>
        {strings.logout}
      </Text>

      <Text style={{ marginVertical: mq(20) }}>
        {strings.are_you_sure_to_logout}
      </Text>

      <View
        style={{
          ...css.rowCenterAlign,
          ...css.fitWidth,
          ...css.centralElements,
        }}
      >
        <Button
          onPress={logout}
          width={"40%"}
          loading={logoutLoading}
          bgColor={colors.danger}
          title={{ value: strings.logout_from_account, size: "sm" }}
        />
        <View style={{ width: sizes.space }} />
        <Button
          onPress={cancel}
          width={"40%"}
          outline
          bgColor={colors.danger}
          title={{ value: strings.cancel, size: "sm" }}
        />
      </View>
    </View>
  );
}

export default function Logout() {
  const { flg: modal, on: showModal, off: hideModal } = useFlag();

  const logoutMut = useLogout();

  const _onLogoutConfirm = (close: () => void) => logoutMut.mutate();

  return (
    <>
      <Button
        onPress={showModal}
        width={mq(70)}
        contentSeparator={10}
        bgColor={colors.transparent}
        style={{ ...css.selfEnd, marginVertical: mq(5) }}
        icon={{ name: "power", size: 20, color: colors.danger }}
        title={{
          size: "md",
          weight: "bold",
          color: colors.danger,
          value: strings.logout,
        }}
      />

      <ConfirmAlert
        force
        show={modal}
        hide={hideModal}
        renderContent={(close) => (
          <LogoutAlertContent
            logoutLoading={logoutMut?.isLoading}
            logout={() => _onLogoutConfirm(close)}
            cancel={close}
          />
        )}
      />
    </>
  );
}
